module.exports = __webpack_public_path__ + "static/media/st.48e5f091.svg";